import React from 'react';

import { GenericSpan, GenericP } from 'commonStyles';

const DateData = ({ travelDate, endDate, travelTime }) => (
	<GenericSpan>
		{endDate ? (
			<>
				<GenericP fsize='14px' $lHeight='20px' color='#000'>{travelDate} -</GenericP>
				<GenericP fsize='14px' $lHeight='20px' color='#000'>{endDate}</GenericP>
			</>
		) : (
			<GenericP fsize='14px' $lHeight='20px' color='#000'>{travelDate}</GenericP>
		)}
		{travelTime && (
			<GenericP fsize='12px' $lHeight='16px' color='#757575'>{travelTime}</GenericP>
		)}
	</GenericSpan>
);

export default DateData;
